module.exports = __webpack_public_path__ + "img/blue.af6a5597.png";